{
  "name": "plp-une-f-onboarding",
  "version": "1.4.0",
  "private": true,
  "dependencies": {
    "@angular/cdk": "^19.2.19",
    "@angular/common": "^19.2.0",
    "@angular/compiler": "^19.2.0",
    "@angular/core": "^19.2.0",
    "@angular/forms": "^19.2.0",
    "@angular/material": "^19.2.19",
    "@angular/platform-browser": "^19.2.0",
    "@angular/platform-browser-dynamic": "^19.2.0",
    "@angular/router": "^19.2.0",
    "@jsverse/transloco": "^8.2.1",
    "@stomp/stompjs": "^7.3.0",
    "@techiediaries/ngx-qrcode": "^9.1.0",
    "binlookup": "^2.0.1",
    "crypto-js": "^4.2.0",
    "express": "^5.2.1",
    "file-saver": "^2.0.5",
    "html2canvas": "^1.4.1",
    "jspdf": "^4.2.0",
    "jspdf-autotable": "^5.0.7",
    "jszip": "^3.10.1",
    "qrcode": "^1.5.4",
    "rxjs": "~7.8.0",
    "sockjs-client": "^1.6.1",
    "tslib": "^2.3.0",
    "tweetnacl": "^1.0.3",
    "tweetnacl-util": "^0.15.1",
    "xlsx": "^0.18.5",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.22",
    "@angular/cli": "^19.2.22",
    "@angular/compiler-cli": "^19.2.0",
    "@types/crypto-js": "^4.2.2",
    "@types/file-saver": "^2.0.7",
    "@types/html2canvas": "^0.5.35",
    "@types/jasmine": "~5.1.0",
    "@types/jspdf": "^1.3.3",
    "@types/qrcode": "^1.5.6",
    "@types/sockjs-client": "^1.5.4",
    "@types/stompjs": "^2.3.10",
    "@types/xlsx": "^0.0.35",
    "husky": "^9.1.7",
    "jasmine-core": "~5.6.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.7.2"
  },
  "scripts": {
    "ng": "ng",
    "start": "ng serve --configuration development",
    "start:dev": "ng serve --configuration development",
    "start:stage": "ng serve --configuration staging",
    "build": "ng build",
    "build:dev": "ng build --configuration development",
    "build:stage": "ng build --configuration staging",
    "build:prod": "ng build --configuration production",
    "build:stats": "ng build --configuration production --stats-json",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "i18n:check": "node scripts/check-i18n.mjs",
    "colors:check": "node scripts/check-colors.mjs",
    "colors:check:all": "node scripts/check-colors.mjs --all",
    "sepomex:build": "node scripts/build-sepomex-dataset.mjs",
    "prepare": "husky"
  }
}
